export default "__VITE_ASSET__f5c0875d__"